import { useStyletron } from "baseui";
import { LabelSmall, ParagraphSmall } from "baseui/typography";


export type ObjectAvatarProps = {
    name?: string,
    icon?: any,
    backgroundColor?: string
}
export const ObjectAvatar = ({ icon, name, backgroundColor }: ObjectAvatarProps) => {
    const [css, theme] = useStyletron();

    const fullname = name !== undefined ? name : "Anonymous";
    return (
        <div
            className={css({
                minWidth: theme.sizing.scale1200,
                minHeight: theme.sizing.scale1200,
                borderRadius: '50%',
                backgroundColor: backgroundColor || theme.colors.contentPrimary,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
            })}>
            {icon && <div
                className={css({
                    width: theme.sizing.scale800,
                height: theme.sizing.scale800,
                    color: theme.colors.backgroundPrimary
                })}>{icon}</div>}
            {!icon && <><ParagraphSmall color={theme.colors.backgroundPrimary}>{getInitials(fullname)}</ParagraphSmall></>}
        </div>

    )
}

function getInitials(name: string) {
    const fullName = name.split(' ');
    const char1 = fullName.shift()?.charAt(0) || "";
    const char2 = fullName.pop()?.charAt(0) || "";
    return (char1 + char2).toUpperCase();

    /*const fullName = name.split(' ');
    if (fullName !== undefined) {
        const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
        return initials.toUpperCase();
    }*/
    return name.charAt(0);
}
